import { gql } from "@apollo/client";

export const GET_MAILS = gql`
	query Mails(
		$setId: UUID!
		$before: String
		$after: String
		$first: Int
		$last: Int
		$where: [MailFilterInput!]
		$order: [MailSortInput!]
	) {
		mails(
			before: $before
			after: $after
			first: $first
			last: $last
			where: { mailSet: { id: { eq: $setId } }, and: $where }
			order: $order
		) {
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				id
				fromMailAddress
				fromDisplay
				bccRecipients
				ccRecipients
				dateTimeStamp
				identifier
				metaData {
					fileName
					description {
						relatedEmailAddress
						relationshipNumber
					}
				}
				logs {
					id
					dateTimeStamp
					status
				}
				status
				mailSet {
					id
				}
				templateId
			}
		}
	}
`;
